var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg elevation-12",attrs:{"rounded":""}},[_c('v-toolbar',{attrs:{"color":"primary","height":"56","dark":"","flat":""}},[_c('h3',[_vm._v("Message")])]),_c('v-card-text',[_c('v-container',[_c('h2',[_vm._v(_vm._s(_vm.message))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }